//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';
import universalImageActionsTributaryCustomizeProductsTemplate from '@legacy-components/common/universal-image-actions/universal-image-actions-tributary-customize-products.html';

export class UniversalImageActionsTributaryCustomizeProducts {
  public state;
  public universalItemId: string;

  constructor(
        private ShowroomService,
        private UniversalImageActionsService,
        private SHOWROOM_PREVIEW_SECTIONS,
    ) { }

  public onFiltersUpdated = (newFilterState) => {
    this.updatePreviewForProducts(
            newFilterState,
            null,
            null,
            () => { this.ShowroomService.updateFilters(newFilterState); },
        );
  }

  public onProductsUpdated = (newProductList) => {
    this.updatePreviewForProducts(
            null,
            newProductList,
            null,
            () => { this.ShowroomService.updateProductsList(newProductList); },
        );
  }

  public onUpdateCuratedProductsState = (newCuratedProductState) => {
    this.updatePreviewForProducts(
            null,
            null,
            newCuratedProductState,
            () => { this.ShowroomService.onUpdateCuratedProductsState(newCuratedProductState); },
        );
  }

  public $onInit() {
    const launchOptions = this.UniversalImageActionsService.getCurrentLaunchOptions();
    this.universalItemId = launchOptions.getUniversalItemId();

    this.state = {
      loaded: false,
    };

    this.ShowroomService.getCurrentConfigStatusObservable().subscribe((currentState) => {
      this.state = angular.copy(currentState);
    });

    this.ShowroomService.loadExistingState(this.universalItemId);
  }

    //
    // Private helpers
    //

  private updatePreviewForProducts = (newFilterState, newProductList, newCuratedProductsState, callback) => {
    const filterState = newFilterState || this.state?.filters?.filterState;

    const productList = newProductList || this.state?.curatedProducts;

    const curatedProductsState = newCuratedProductsState || this.state?.curatedProductsState;
    const curatedRecsBoolean = this.ShowroomService.getCuratedRecsBoolean(
            curatedProductsState,
            this.state.curatedMediaState,
        );

    this.ShowroomService.updatePreview(
            this.universalItemId,
            this.state.impl.id,
            this.state.impl.name,
            this.state.impl.implementationType,
            this.state.impl.sourceId,
            filterState,
            this.state?.passthrough?.showDesktopExperience,
            this.state?.passthrough?.passthroughUrl,
            this.state?.emailCaptureState,
            this.state?.customStringsState,
            this.state?.curatedRecsId,
            curatedRecsBoolean,
            productList,
            this.state?.selectedLabels,
            curatedProductsState,
            this.state?.curatedMediaState,
            this.SHOWROOM_PREVIEW_SECTIONS.PRODUCTS,
            callback,
        );
  }
}

angular.module('uia').component('universalImageActionsTributaryCustomizeProducts', {
  template: universalImageActionsTributaryCustomizeProductsTemplate,
  controller: [
    'ShowroomService',
    'UniversalImageActionsService',
    'SHOWROOM_PREVIEW_SECTIONS',
    UniversalImageActionsTributaryCustomizeProducts,
  ],
});
